module.exports = __webpack_public_path__ + "static/media/register.402084b8.png";